@if (platformBrowser) {
<div class="page">
  <app-tenant-logo-and-contacts [tenant]="tenant"></app-tenant-logo-and-contacts>
  <div class="galleries-container">
    @if (galleries.length) {
    <div class="galleries">
      @for (gallery of galleries; track gallery) {
      <a [routerLink]="[gallery.path]" target="_blank">
        <app-gallery-item [gallery]="gallery" [publicMode]="true" [showPasswordProtected]="true"></app-gallery-item>
      </a>
      }
    </div>
    }
  </div>
  @if (!galleries.length) {
  <div class="no-galleries" [class.with-logo]="tenant.logo_url">
    <span>There are no galleries to show.</span>
  </div>
  } @if (tenant.picflow_branding_enabled) {
  <app-made-with-picflow-button [tenantId]="tenant.id"> </app-made-with-picflow-button>
  }
</div>
} @if (!platformBrowser) {
<div class="page center tiny loading">
  <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
</div>
}
